var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"errPage-container"},[_c('el-row',[_c('el-col',{attrs:{"span":12}},[_c('h1',{staticClass:"text-jumbo text-ginormous"},[_vm._v(" 抱歉! ")]),_c('h2',[_vm._v(_vm._s(_vm.errorMessage))]),_c('h6',[_vm._v("如有需要请联系您领导")])]),_c('el-col',{attrs:{"span":12}},[_c('img',{attrs:{"src":_vm.errGif,"width":"313","height":"428"}})])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }